export default "__VITE_ASSET__DuvNC2pW__"